module.exports = __webpack_public_path__ + "img/Stab_Ko.13d51cc6.svg";